import { JqlQuery } from '@qality/common-model';

import JqlClauseBuilder from './JqlClauseBuilder';

class JqlQueryBuilder implements JqlQuery {
  orderByProperty: string;
  jqlClauseBuilder: JqlClauseBuilder;

  constructor() {
    this.orderByProperty = '';
  }

  orderBy(property: string): this {
    this.orderByProperty = property;
    return this;
  }

  where(): JqlClauseBuilder {
    this.jqlClauseBuilder = new JqlClauseBuilder(this);
    return this.jqlClauseBuilder;
  }

  build(): string {
    const clause = this.jqlClauseBuilder?.build() ?? '';
    const isClauseEmpty = clause.length === 0;
    const isOrderByPropertyEmpty = this.orderByProperty.length === 0;

    if (isOrderByPropertyEmpty) {
      return clause;
    }

    if (isClauseEmpty) {
      return `order by ${this.orderByProperty}`;
    }

    return `${clause} order by ${this.orderByProperty}`;
  }
}

export default JqlQueryBuilder;
